<template>
  <div :class="classes" :style="styl">
    <slot></slot>
  </div>
</template>

<script>
const PREFIXCLS = 'row'
export default {
  name: 'TRow',
  props: {
    // props data
    gutter: {
      // 间距
      type: [String, Number],
      default: null
    },
    align: {
      // 垂直对齐
      type: String,
      default: '',
      validator(value) {
        return ['', 'start', 'center', 'end'].includes(value)
      }
    },
    justify: {
      // 水平对齐
      type: String,
      default: '',
      validator(value) {
        return ['', 'start', 'end', 'center', 'around', 'between'].includes(
          value
        )
      }
    }
  },
  data: function() {
    // store data
    return {}
  },
  computed: {
    classes() {
      let _classes = []
      _classes.push(`${PREFIXCLS}`)
      // 间距
      const _gutter = Number.parseInt(this.gutter)
      if (_gutter === 0) {
        _classes.push(`no-gutters`)
      }
      // 垂直对齐
      if (this.align) {
        _classes.push(`align-items-${this.align}`)
      }
      // 水平对齐
      if (this.justify) {
        _classes.push(`justify-content-${this.justify}`)
      }
      return _classes.join(' ')
    },
    styl() {
      const _gutter = Number.parseInt(this.gutter)
      if (_gutter) {
        const _margin = `${this.gutter / 2}px`
        return {
          marginLeft: `-${_margin}`,
          marginRight: `-${_margin}`
        }
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// row.vue?fb773b78